import { render, staticRenderFns } from "./SuspensionApproval.vue?vue&type=template&id=15455c90&scoped=true"
import script from "./SuspensionApproval.vue?vue&type=script&lang=js"
export * from "./SuspensionApproval.vue?vue&type=script&lang=js"
import style0 from "./SuspensionApproval.vue?vue&type=style&index=0&id=15455c90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15455c90",
  null
  
)

export default component.exports